module.exports = __webpack_public_path__ + "static/22-SER-RAKIA.04f80780.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/22-SER-RAKIA.png
// module id = 618
// module chunks = 35783957827783